var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,36.095c-1.104,0-2,0.896-2,2v29.669c0,1.104,0.896,2,2,2s2-0.896,2-2V38.095C50,36.99,49.104,36.095,48,36.095z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.715,45.957c-1.104,0-2,0.896-2,2V64.78c0,1.104,0.896,2,2,2s2-0.896,2-2V47.957 C35.715,46.852,34.82,45.957,33.715,45.957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.857,40.634c-1.104,0-2,0.896-2,2v23.887c0,1.104,0.896,2,2,2s2-0.896,2-2V42.634 C42.857,41.529,41.962,40.634,40.857,40.634z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.36,26.236H29.639c-5.236,0-9.496,4.26-9.496,9.496s4.26,9.497,9.496,9.497s9.496-4.26,9.496-9.497c0-1.104-0.896-2-2-2 s-2,0.896-2,2c0,3.031-2.465,5.497-5.496,5.497s-5.496-2.466-5.496-5.497s2.465-5.496,5.496-5.496H66.36 c3.031,0,5.497,2.465,5.497,5.496s-2.466,5.497-5.497,5.497c-3.03,0-5.496-2.466-5.496-5.497c0-1.104-0.896-2-2-2s-2,0.896-2,2 c0,5.236,4.26,9.497,9.496,9.497s9.497-4.26,9.497-9.497S71.597,26.236,66.36,26.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.284,45.957c-1.104,0-2,0.896-2,2V64.78c0,1.104,0.896,2,2,2s2-0.896,2-2V47.957 C64.284,46.852,63.389,45.957,62.284,45.957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.143,40.634c-1.104,0-2,0.896-2,2v23.887c0,1.104,0.896,2,2,2s2-0.896,2-2V42.634 C57.143,41.529,56.247,40.634,55.143,40.634z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemple);
export default __webpack_public_path__ + "static/media/temple.26eb689afc71d41a867d0f435a0ba076.svg";
export { ForwardRef as ReactComponent };